import React, { useState, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { 
  Select, 
  MenuItem, 
  FormControl,
  Paper,
  Typography,
  Box
} from '@mui/material';

const MapSpeciesFilter = ({ speciesData, onFilterChange }) => {
  const [selectedSpecies, setSelectedSpecies] = useState('all');
  const map = useMap();
console.log("Species data in MapSpeciesFilter:", speciesData);
  // Disable map interaction when the select is open
  useEffect(() => {
    const selectContainer = document.querySelector('.species-select-container');
    if (selectContainer) {
      selectContainer.addEventListener('mouseenter', () => {
        if (map) {
          map.dragging.disable();
          map.scrollWheelZoom.disable();
        }
      });
      
      selectContainer.addEventListener('mouseleave', () => {
        if (map) {
          map.dragging.enable();
          map.scrollWheelZoom.enable();
        }
      });
    }

    return () => {
      if (map) {
        map.dragging.enable();
        map.scrollWheelZoom.enable();
      }
    };
  }, [map]);

  const handleSpeciesChange = (event) => {
    const value = event.target.value;
    setSelectedSpecies(value);
    onFilterChange(value);
  };

  // Stop event propagation to prevent map interaction
  const handleSelectClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Box 
      onClick={handleSelectClick}
      sx={{
        position: 'absolute',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        maxHeight: '60vh',
        margin:'10px',
        maxWidth: '30%',
        width: '30%',
      }}
    >
      <Paper 
        elevation={3}
        sx={{
          p: 2,
          overflow: 'hidden',
          background: 'linear-gradient(to bottom, #fafafa, #f5f5f5)',
          border: '1px solid #e0e0e0'
        }}
      >
        <FormControl 
          fullWidth 
          sx={{ 
            mb: 2,
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#7EA10D',
              '&:hover': {
                backgroundColor: '#8FBF26'
              },
              '& .MuiSelect-select': {
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }
            }
          }}
        >
          <Select
            value={selectedSpecies}
            onChange={handleSpeciesChange}
            displayEmpty
            sx={{ minWidth: 0, width: '100%' }}
            size='small'
            renderValue={(selected) => (selected === "all" ? "Biodiversity Filter" : selected)}
          >
            <MenuItem value="all">All Species</MenuItem>
            {Object.entries(speciesData).map(([species, data]) => (
              <MenuItem 
                key={species} 
                value={species}
                sx={{
                  '&:hover': {
                    backgroundColor: '#8FBF26'
                  },
                  '&.Mui-selected': {
                    backgroundColor: '#7EA10D'
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <img 
                    src={data.icon || '/images/icon/leaf.png'} 
                    alt={species}
                    style={{ width: 20, height: 20, objectFit: 'contain' }}
                  />
                  <span style={{color: '#000000'}}>{species}</span>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box className="legend">
          <Box 
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
              maxHeight: 'calc(60vh - 100px)',
              overflowY: 'auto',
              pr: 1
            }}
          >
            {Object.entries(speciesData).map(([species, data]) => (
              <Box 
                key={species}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: 1,
                  backgroundColor: '#f5f5f5',
                  '&:hover': {
                    backgroundColor: '#e3f2fd'
                  },
                  transition: 'background-color 0.2s'
                }}
              >
                <Box 
                  sx={{
                    width: 32,
                    height: 32,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    boxShadow: 1,
                    p: 0.5,
                    marginRight: 1,
                    marginLeft: 1
                  }}
                >
                  <img 
                    src={data.icon || '/images/icon/leaf.png'}
                    alt={species}
                    style={{ minwidth: 22, minHeight: 22, objectFit: 'contain'}}
                  />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row',gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {species}
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500 }} >
                    ({data.count + 1}) trees
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default MapSpeciesFilter;